<template>
  <div class="ei-long-figure-scroll-auto">
    <div class="scroll-white" :style="{'--width':boxWidth+'px'}"></div>
    <div class="scroll-content multiply"
         :style="{backgroundImage:'url('+imgUrl+')',animationDuration:duration+'s','--width':boxWidth+'px'}"
         ref="scrollContent"></div>
    <div class="scroll-content multiply"
         :style="{backgroundImage:'url(/upload/longfigure/bg.jpg)',animationDuration:duration+'s','--width':boxWidth+'px'}"
         ref="scrollContent"></div>
  </div>
</template>

<script>
export default {
  name: 'EiLongFigureScrollAuto',
  data () {
    return {
      duration: 0,
      bgWidth: 1927
    }
  },
  props: {
    boxWidth: {
      type: Number,
      required: true
    },
    imgUrl: {
      type: String,
      required: true
    },
    imgWidth: {
      type: Number,
      required: true
    },
    speed: {
      type: Number,
      default: 30
    }
  },
  mounted () {
    this.duration = parseInt(this.imgWidth / this.speed)
    let startX = this.boxWidth - this.imgWidth
    let endX = this.boxWidth + this.imgWidth
    let startX_bg = this.boxWidth - this.bgWidth
    let endX_bg = this.boxWidth + this.bgWidth
    let style = document.createElement('style')
    document.getElementsByTagName('head')[0].appendChild(style)
    style.appendChild(document.createTextNode(''))
    document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes scroll{
                0%{  background-position-x: ${startX}px;}
                100%{ background-position-x: ${endX}px;}
            }
     `)
    document.styleSheets[document.styleSheets.length - 1].insertRule(`
      @keyframes scroll-bg{
                0%{  background-position-x: ${startX_bg}px;}
                100%{ background-position-x: ${endX_bg}px;}
            }
    `)

  }
}
</script>

<style scoped lang="scss">
.ei-long-figure-scroll-auto {
  position: relative;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.scroll-white {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--width);
  height: 483px;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
}

.scroll-content {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--width);
  height: 480px;
  cursor: pointer;
  overflow: hidden;
  background-repeat: repeat-x;
  background-size: auto 480px;
  animation-name: scroll;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-play-state: running;
  z-index: 2;
}


.scroll-content-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--width);
  height: 480px;
  cursor: pointer;
  overflow: hidden;
  background-repeat: repeat-x;
  background-size: auto 480px;
  animation-name: scroll-bg;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-play-state: running;
  z-index: 2;
}

.ei-long-figure-scroll-auto:hover .scroll-content,.scroll-content-bg {
  animation-play-state: paused;
}

.multiply {
  background-blend-mode: multiply;
  mix-blend-mode: multiply;
}
</style>
